module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: {
      'fa kp-panel-alternative': _vm.step.kind === 'multiple-choice',
      'fa kp-panel-yes-no': _vm.step.kind === 'yes-no',
      'fa kp-panel-register': _vm.step.kind === 'email',
      'fa icon-kp-link': _vm.step.kind === 'redirect',
      'fa kp-panel-text': _vm.step.kind === 'text'
    }
  })
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-65883822!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/steps/Icon.vue
 ** module id = 850
 ** module chunks = 1
 **/